enum WorkItemDefinitionType {
  TASK = 'TASK',
  AGGREGATOR = 'AGGREGATOR',
}

export default WorkItemDefinitionType;
